export default "__VITE_ASSET__Ddmf7G7m__"